"use client";

import classNames from "classnames";
import { ChevronLeftIcon, ChevronRightIcon } from "@vetty/icons";
import { Button } from "../button";
import { Select } from "../select";
import { PaginationTypes } from "./Pagination.types";
import styles from "./Pagination.module.scss";

const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 20, 50];

export const Pagination = ({
  page,
  limit,
  total,
  totalPages,
  rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS,
  className = "",
  onPageChange,
  onRowsPerPageChange,
}: PaginationTypes) => {
  const safeTotal = Math.max(total, 0);
  const currentFrom = safeTotal === 0 ? 0 : (page - 1) * limit + 1;
  const currentTo = safeTotal === 0 ? 0 : Math.min(page * limit, safeTotal);

  return (
    <div className={classNames(styles["comp"], className)}>
      <div className={styles["comp__rows"]}>
        <span className={styles["comp__label"]}>Show rows per page</span>
        <Select
          size="medium"
          variant="secondary"
          value={String(limit)}
          dropdownPlacement="top"
          onChange={(value) => onRowsPerPageChange(Number(value))}
        >
          {rowsPerPageOptions.map((option) => (
            <option key={option} value={String(option)}>
              {option}
            </option>
          ))}
        </Select>
      </div>

      <div className={styles["comp__summary"]}>
        <div className={styles["comp__count"]}>
          <span>
            {currentFrom}-{currentTo}
          </span>{" "}
          of {safeTotal}
        </div>

        <div className={styles["comp__actions"]}>
          <Button
            size="small"
            variant="secondary"
            className={styles["comp__nav-button"]}
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            <ChevronLeftIcon style={{ width: 20, height: 20 }} />
          </Button>

          <div className={styles["comp__page"]}>
            Page {Math.min(page, Math.max(totalPages, 1))} of {Math.max(totalPages, 1)}
          </div>

          <Button
            size="small"
            variant="secondary"
            className={styles["comp__nav-button"]}
            disabled={page >= totalPages || safeTotal === 0}
            onClick={() => onPageChange(page + 1)}
          >
            <ChevronRightIcon style={{ width: 20, height: 20 }} />
          </Button>
        </div>
      </div>
    </div>
  );
};
